export default __webpack_public_path__ + "static/media/glad.43160305.jpg";